<template>
  <!-- 样本列表视图 -->
  <div class="sample-list">
    <div v-if="samplesprop.length == 0">
      <div style="margin-top: 50%; transform: translateY(-50%)">
        <empty text="没有样本"></empty>
      </div>
    </div>
    <q-virtual-scroll v-else :items="samplesprop" style="height: 500px">
      <template v-slot="{ item, index }" style="height: 500px">
        <div :key="index" class="sample-item">
          <div class="q-pl-md q-pt-sm" style="width: 80%; cursor: pointer">
            <p class="sample-name text-subtitle2 text-bold q-pa-none q-ma-none">
              <!-- {{ item.detail.name }} -->
              <MatchHighlight
                class-name="tlqn-ad-gmls-search-match"
                :keyword="searchKeyword"
                :text="item.detail.name"
              />
            </p>
            <p class="q-mb-none">
              <MatchHighlight
                class-name="tlqn-ad-gmls-search-match"
                :keyword="searchKeyword"
                :text="item.detail.sample_id"
              />
            </p>
            <p class="sample-address">
              {{ item.detail.dom }}
            </p>
            <p>
              <q-chip
                :style="{
                  background: item.user === null ? '#124561' : '#DF602F',
                  fontSize: '0.8rem',
                }"
                text-color="white"
                dense
              >
                {{ item.user === null ? "未分配" : "已分配" }}
              </q-chip>

              <q-chip
                :style="{
                  background: sampleStatusDict[item.sample_status].color,
                  fontSize: '0.8rem',
                }"
                text-color="white"
                dense
              >
                {{ sampleStatusDict[item.sample_status].description }}
              </q-chip>
            </p>

            <q-menu>
              <div style="width: 450px">
                <q-card-section class="row items-center q-pb-none">
                  <div class="text-h6 text-weight-bold">样本信息</div>
                  <q-space />
                  <q-btn icon="fas fa-times" flat round dense v-close-popup />
                </q-card-section>

                <q-card-section class="q-pa-md">
                  <div class="row no-wrap items-center">
                    <div
                      style="
                        min-width: 50px;
                        min-height: 50px;
                        background: #3f89bd;
                        border-radius: 10px;
                      "
                      class="row justify-center items-center"
                    >
                      <q-icon
                        class="fas fa-building"
                        style="font-size: 30px; margin: 0 auto; color: #ffffff"
                      ></q-icon>
                    </div>
                    <div
                      style="
                        margin-top: 0px;
                        margin-left: 10px;
                        font-size: 0.8rem;
                      "
                      class="sample-dialog-info"
                    >
                      <p>
                        <span class="text-subtitle2">样本ID: </span>
                        {{ item.detail.sample_id }}
                      </p>
                      <p>
                        <span class="text-subtitle2">名称: </span>
                        {{ item.detail.name }}
                      </p>
                      <p>
                        <span class="text-subtitle2">注册地址: </span>
                        {{ item.detail.dom }}
                      </p>

                      <p>
                        <span class="text-subtitle2">经营地址: </span>
                        <span v-if="item.detail.addr">
                          {{ item.detail.addr }}
                        </span>
                        <span v-else class="text-grey">无</span>
                      </p>

                      <p>
                        <span class="text-subtitle2">组长备注: </span>
                        {{
                          item.detail.leader_note == null
                            ? "无"
                            : item.detail.leader_note
                        }}
                      </p>
                      <p>
                        <span class="text-subtitle2">访员备注: </span>
                        {{
                          item.detail.member_note == null
                            ? "无"
                            : item.detail.member_note
                        }}
                      </p>
                    </div>
                  </div>

                  <p></p>
                  <p
                    class="
                      text-subtitle1 text-grey-8 text-weight-bold
                      q-mt-md q-mb-none
                    "
                  >
                    添加备注
                  </p>

                  <q-input
                    filled
                    type="textarea"
                    v-model="remarks"
                    rows="2"
                    style="background: rgba(33, 33, 33, 0.08)"
                  />
                  <div class="row">
                    <q-space />
                    <q-btn
                      unelevated
                      rounded
                      text-color="white"
                      color="primary"
                      style="margin-top: 10px"
                      @click="addRemarks(item.detail.sample_id)"
                    >
                      <span>确定</span>
                    </q-btn>
                  </div>
                </q-card-section>
              </div>
            </q-menu>
          </div>

          <div class="sample-principal">
            <p class="q-ma-none q-pa-none text-bold" style="font-size: 0.8rem">
              样本负责人
            </p>
            <q-avatar size="60px" class="tlqn-agmli-avatar_display">
              {{ item.user === null ? "无" : item.user.nickname.substr(0, 1) }}
            </q-avatar>
            <p style="margin-bottom: 0; font-size: 0.8rem">点击编辑</p>

            <q-menu>
              <div style="width: 350px">
                <div>
                  <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6" style="font-weight: 600">
                      切换样本负责人
                    </div>
                    <q-space />
                    <q-btn icon="fas fa-times" flat round dense v-close-popup />
                  </q-card-section>
                  <p style="margin: 10px 15px">名称：{{ item.detail.name }}</p>
                  <p style="margin: 10px 15px">
                    负责人：{{
                      item.user === null ? "未指定" : item.user.nickname
                    }}
                  </p>

                  <q-btn
                    v-if="item.user != null && item.sample_status == 1"
                    flat
                    class="text-red bg-white shadow-22"
                    @click="deleteBindUserAndSample(item.id)"
                    style="margin: 10px"
                    v-close-popup
                  >
                    <q-icon
                      name="fas fa-trash"
                      size="12px"
                      class="q-mr-sm"
                    ></q-icon>
                    <span>取消关联</span>
                  </q-btn>
                </div>

                <div v-if="item.sample_status != 1">
                  <p
                    style="
                      margin-left: 50%;
                      transform: translate(-50%);
                      font-weight: 600;
                    "
                  >
                    <span
                      :style="{
                        color: sampleStatusDict[item.sample_status].color,
                      }"
                    >
                      样本{{
                        sampleStatusDict[item.sample_status].description
                      }}，不能操作
                    </span>
                  </p>
                </div>
                <div v-else>
                  <q-list
                    v-for="memberItem in membersprop"
                    :key="memberItem.id"
                    clickable
                  >
                    <q-item
                      clickable
                      v-close-popup
                      @click="switchSamplePrincipal(item.id, memberItem.id)"
                    >
                      <q-item-section avatar>
                        <q-avatar size="60px" class="tlqn-agmli-avatar_display">
                          {{ memberItem.nickname.substr(0, 1) }}
                        </q-avatar>
                      </q-item-section>

                      <q-item-section>
                        <span class="text-subtitle1">
                          <span class="text-weight-bold">{{
                            memberItem.nickname
                          }}</span>
                          完成样本
                          {{
                            statisticCompleteOfSample(memberItem.samples).sum
                          }}
                          /
                          {{ memberItem.samples.length }}
                        </span>
                        <line-progress
                          :progress="
                            statisticCompleteOfSample(memberItem.samples).res
                          "
                        ></line-progress>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </div>
              </div>
            </q-menu>
          </div>
        </div>
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import LeaderCommonStatus from "../mixins/status.mixin";
import { updateLeaderNote } from "../../../api/endpoints/sample-detail/updateLeaderNote";
import { updateBindUser } from "../../../api/endpoints/sample/updateBindUser";
import { deleteBindUser } from "../../../api/endpoints/sample/deleteBindUser";
import { SAMPLE_STATUS_DICT } from "../../../../../shared/constants/sample-status";

export default {
  mixins: [LeaderCommonStatus],
  props: ["samplesprop", "membersprop", "searchKeyword"],
  components: {
    LineProgress: () => import("../../../components/progress-bar/LineProgress"),
    Empty: () => import("../../../components/Empty.vue"),
    Loading: () => import("../../../components/Loading.vue"),
    MatchHighlight: () => import("@/components/MatchHighlight"),
  },
  data() {
    return {
      loading: false,
      remarks: "", // 备注
      sampleStatusDict: SAMPLE_STATUS_DICT,
    };
  },
  watch: {},

  mounted() {},

  methods: {
    /**
     * 切换样本负责人
     */
    async switchSamplePrincipal(needSwitchSampleId, newPrincipalMemberId) {
      try {
        const response = await updateBindUser(
          needSwitchSampleId,
          newPrincipalMemberId
        );
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.updateCurrentGroupLeaderStatus(
            "is_request",
            newPrincipalMemberId + Math.random()
          );
          this.$q.notify({
            type: "positive",
            message: "成功指定样本负责人",
          });
        }
      } catch (err) {
        this.q.notify({ type: "danger", name: "指定样本负责人错误" });
      }
    },

    /**
     * 取消关联
     */
    async deleteBindUserAndSample(sampleId) {
      console.log(sampleId);
      try {
        const response = await deleteBindUser(sampleId);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.updateCurrentGroupLeaderStatus("is_request", sampleId);
          this.$q.notify({
            type: "positive",
            message: "已经取消关联",
          });
        }
      } catch (err) {
        this.q.notify({ type: "danger", name: "取消关联失败" });
      }
    },

    /**
     * 统计样本完成情况
     */
    statisticCompleteOfSample(sampleList) {
      let totalSamples = sampleList.length;
      if (totalSamples == 0) return { sum: 0, res: 0 };
      let sum = 0; // 记录已经完成的样本数量
      sampleList.forEach((sample) => {
        if (sample.sample_status === 0) sum++;
      });
      let res = Math.round((sum / totalSamples) * 100);
      return { sum: sum, res: res };
    },

    /**
     * 添加备注
     */
    async addRemarks(sampleId) {
      console.log(this.remarks, sampleId);
      try {
        const response = await updateLeaderNote(sampleId, this.remarks);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.updateCurrentGroupLeaderStatus("is_request", sampleId);
          this.$q.notify({
            type: "positive",
            message: "已添加备注",
          });
        }
      } catch (err) {
        this.$q.notify({
          type: "danger",
          name: "添加备注失败",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
.sample-list {
  width: 92%;
  margin-left: 4%;
  margin-bottom: 20px;
  max-height: 500px;
}

.sample-list .sample-item {
  background: #ffffff;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  margin: 14px 0;
  display: flex;
  position: relative;

  .sample-name {
    width: 80%;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sample-address {
    width: 90%;
    height: 30px;
    font-size: 0.8rem;
    line-height: 20px;
  }

  .sample-principal {
    width: 100px;
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    margin-top: 15px;
    margin-right: 20px;
    transition: all 0.5s ease;
    border-radius: 11px;

    p {
      margin-bottom: 0px;
    }

    &::before {
      content: "";
      width: 0;
      height: 80px;
      border-left: 1px solid rgba(30, 20, 40, 0.2);
      position: absolute;
      top: 20px;
      right: 30%;
    }
  }
}

.tlqn-agmli-avatar_display {
  background-color: rgba($primary, 0.2);
  color: $primary;
  font-weight: bold;
}

.sample-dialog-info {
  & > p {
    margin: 0;
  }

  & span {
    font-weight: 600;
  }
}

.tlqn-ad-gmls-search-match {
  background-color: $primary;
  color: #fff;
}
</style>
